import { DisplayType } from '../enums/display-type';

export class WebSocketNotificationMessage {
    public displayType: DisplayType;
    public message: string;

    public static fromJson(other: any): WebSocketNotificationMessage {
        const instance = new WebSocketNotificationMessage();
        instance.message = other.Message;
        instance.displayType = DisplayType[other.DisplayType];
        return instance;
    }
}
